import { motion } from 'framer-motion'
import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Backdrop = styled(motion.div).attrs(props => ({
  ...props,
  initial: { opacity: 0 },
  animate: { opacity: 0.65 },
  exit: { opacity: 0 }
}))`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.zds.colors.neutral200};
  z-index: 10000;
`

export const ChatContainer = styled(motion.div).attrs(props => ({
  ...props,
  initial: { y: '85vh' },
  animate: { y: '0vh' },
  exit: { y: '85vh' },
  transition: { ease: 'easeOut', damping: 0, duration: 0.2 }
}))`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 70vw;
  height: 85vh;

  display: flex;
  flex-direction: column;
  z-index: 10000;
`

export const Content = styled.div.attrs({
  scrollbarBackground: '#f6f7f9'
})`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;
  padding: 24px;
  background: #f6f7f9;

  ${VerticalStyledScrollBar}
`

export const Footer = styled.div`
  width: 100%;
  padding: 1rem;
  background: ${({ theme }) => theme.zds.colors.neutral900};
  padding: 1.5rem 0.5rem 1.5rem 1.5rem;
`
